module.exports = __webpack_public_path__ + "media/confirm_exit.27cd0fe1.ogg";